import { Link } from "react-router-dom";
import logo from "@/assets/1-wood-floors-logo.webp";

const FooterBrand = () => (
  <div className="flex flex-col">
    <Link to="/">
      <img width={227} height={154} loading="lazy" src={logo} alt="1 Wood Floors Livonia MI" className="h-[52px] w-auto brightness-[1.05]" />
    </Link>
    <p
      className="text-[13px] leading-[1.7] max-w-[220px] mt-4"
      style={{ color: "var(--footer-text-secondary)" }}
    >
      Michigan's most credentialed hardwood flooring manufacturer and retailer. Four NWFA Certifications: Installer, Sand and Finish, Inspector, and Sales Advisor.
    </p>

    <div className="mt-8">
      <span
        className="text-[11px] font-semibold tracking-[0.08em] uppercase"
        style={{ color: "var(--footer-text-tertiary)" }}
      >
        Showroom
      </span>
      <address
        className="not-italic text-[13px] leading-[1.7] mt-2 block"
        style={{ color: "var(--footer-text-secondary)" }}
      >
        33475 Seven Mile Road West<br />
        Livonia, MI 48152
      </address>
      <a
        href="https://www.google.com/maps/search/?api=1&query=33475+W+Seven+Mile+Rd+Livonia+MI+48152"
        target="_blank"
        rel="noopener noreferrer"
        className="inline-flex items-center gap-1 text-[12px] font-medium mt-2 transition-all duration-150 group"
        style={{ color: "var(--footer-gold)" }}
      >
        Get Directions
        <span className="inline-block transition-transform duration-150 group-hover:translate-x-[3px]">→</span>
      </a>
    </div>

    <div className="mt-6">
      <span
        className="text-[11px] font-semibold tracking-[0.08em] uppercase"
        style={{ color: "var(--footer-text-tertiary)" }}
      >
        Hours
      </span>
      <div
        className="text-[13px] leading-[2] mt-2"
        style={{ color: "var(--footer-text-secondary)" }}
      >
        <p>Monday  10am to 2:30pm</p>
        <p>Tue to Fri  10am to 5pm</p>
        <p>Saturday  Closed</p>
        <p>Sunday  Closed</p>
      </div>
    </div>
  </div>
);

export default FooterBrand;
